import { Product, ProductCategory } from '@/types/products/product';
import { productCategories } from './categories';
import { afterHours } from './after-hours';

// Central registry of all products
const productRegistry = new Map<string, Product>();

// Register all products
[
  afterHours,
].forEach(product => {
  productRegistry.set(product.meta.id, product);
});

// Utility functions for accessing products
export const getProductById = (id: string): Product | undefined => {
  return productRegistry.get(id);
};

export const getProductBySlug = (slug: string): Product | undefined => {
  return Array.from(productRegistry.values()).find(p => p.meta.slug === slug);
};

export const getAllProducts = (): Product[] => {
  return Array.from(productRegistry.values());
};

export const getFeaturedProducts = (): Product[] => {
  return Array.from(productRegistry.values()).filter(p => p.meta.isFeatured);
};

export const searchProducts = (query: string): Product[] => {
  const lowerQuery = query.toLowerCase();
  return Array.from(productRegistry.values()).filter(product => {
    const meta = product.meta;
    return (
      meta.name.toLowerCase().includes(lowerQuery) ||
      meta.tagline.toLowerCase().includes(lowerQuery) ||
      meta.description.toLowerCase().includes(lowerQuery)
    );
  });
};

export const getProductCategories = (): ProductCategory[] => {
  return productCategories;
};

export const getProductCategoryById = (id: string): ProductCategory | undefined => {
  return productCategories.find(cat => cat.id === id);
};

export const getProductCategoryBySlug = (slug: string): ProductCategory | undefined => {
  return productCategories.find(cat => cat.slug === slug);
};

// Export the registry for advanced use cases
export { productRegistry };
